// extracted by mini-css-extract-plugin
export default {"imageLayer":"imageLayer__1BwU6","rounded":"rounded__3Ktcx","shadow":"shadow__A25WZ"};